import { createBrowserRouter } from "react-router";
import RootLayout from "./RootLayout";
import ProtectedLayout from "./ProtectedLayout";
import PublicLayout from "./PublicLayout";
import ErrorPage from "./ErrorPage";
import RestaurantIdGuard from "./RestaurantIdGuard";

import HomePage from "../pages/HomePage";
import MenuPage from "../pages/MenuPage";
import MenuItemDetailPage from "../pages/MenuItemDetailPage";
import ComboDetailPage from "../pages/ComboDetailPage";
import CheckoutPage from "../pages/CheckoutPage";
import ViewCartPage from "../pages/ViewCartPage";
import TableReservationsPage from "../pages/TableReservationsPage";
import DynamicRoutePage from "../pages/DynamicRoutePage";
import LocationSelector from "../components/LocationSelector";

// 🔥 Shared children routes (no need to repeat)
const restaurantChildren = [
  { index: true, Component: HomePage },
  // Dedicated pages (not dynamic)
  { path: "menu", Component: MenuPage },
  { path: "Table-Reservations", Component: TableReservationsPage },
  // Action pages
  { path: "menu-item/:itemId", Component: MenuItemDetailPage },
  { path: "combo/:comboId", Component: ComboDetailPage },
  { path: "checkout", Component: CheckoutPage },
  { path: "cart", Component: ViewCartPage },
  // Dynamic catch-all (handles blog, contact, events, gallery, story, and any custom pages)
  { path: ":slug", Component: DynamicRoutePage },
];

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    errorElement: <ErrorPage />,
    children: [
      // 🟢 Edit Mode (most specific first)
      {
        path: "/:id/preview/edit",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },

      // 🟢 Preview Mode (second most specific)
      {
        path: "/:id/preview",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },

      // 🟢 Restaurant Mode with ID (with UUID guard)
      // RestaurantIdGuard checks if id is UUID or slug
      // - UUID: renders restaurant routes
      // - Non-UUID (slug): renders DynamicRoutePage
      {
        path: "/:id",
        Component: RestaurantIdGuard,
        children: [
          {
            Component: ProtectedLayout,
            children: restaurantChildren,
          }
        ],
      },

      // Public Routes
      {
        Component: PublicLayout,
        children: [{ path: "select-location", Component: LocationSelector }],
      },

      // Normal Mode - Handles all other routes including dynamic pages
      {
        path: "/",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },
    ],
  },
]);
